module.exports = __webpack_public_path__ + "media/images/chevron-up-a09c3ebe3004a10c5e15cb318d3cd51b.svg";